export const SCANNING_METHOD_AUTOMATIC = 'automatic';
export const SCANNING_METHOD_MANUAL = 'manual';
